// Import model
import { LabelFieldOptions } from '../models/LabelFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LabelFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class LabelFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a LabelFieldOptions instance
   */
  static deserialize(json: string): LabelFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LabelFieldOptions instance
   */
  static fromObject(obj: any): LabelFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LabelFieldOptions');
    }


    const instance: LabelFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      style: obj['Style'] as string | undefined,
      color: obj['Color'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LabelFieldOptions instances
   */
  static deserializeArray(json: string): LabelFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LabelFieldOptions instance to a JSON string
   */
  static serialize(instance: LabelFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LabelFieldOptions instance to a plain object
   */
  static toObject(instance: LabelFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Style': instance.style,
      'Color': instance.color,
    };
  }

  /**
   * Serializes an array of LabelFieldOptions instances to a JSON string
   */
  static serializeArray(instances: LabelFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
